import * as appSelectors from 'common/core/selectors/appSelectors'

export const hasUnreadNotifications = (state) => {
  return (
    appSelectors.getCurrentAccount(state)?.last_devlog_critical_message_ts >
    appSelectors.getCurrentAccountUser(state)?.last_devlog_message_read_ts
  )
}
